import type chatZh from '../zh/chat';

const chat: typeof chatZh = {
  placeholder: 'Type a message. Enter to send, Shift+Enter for a new line',
  send: 'Send',
  empty: 'No messages yet. Say hello',
  idle: 'Select a conversation on the left to start chatting',
  emoji: 'Emoji',
  image: 'Image',
  file: 'File',
  script: 'Script',
  hint_enter: 'Enter to send, Shift + Enter for a new line',
  hint_mod: 'Ctrl + Enter to send, Enter for a new line',
  hint_ctrl_newline: 'Enter to send, Ctrl + Enter for a new line',
  online: 'Online',
  no_earlier: 'No earlier messages',
  new_messages: '{{count}} new messages',
  sent: 'Sent',
  delivered: 'Delivered',
  read: 'Read',
  sending: 'Sending',
  send_failed_retry: 'Failed to send. Click to retry',
  send_failed: 'Failed to send',
  view: 'View',
  today: 'Today',
  yesterday: 'Yesterday',
  same_year: '{{month}}/{{day}}',
  full: '{{month}}/{{day}}/{{year}}',
  me: 'Me',
  me_prefix: 'Me: ',
  self_initial: 'M'
};

export default chat;
